<template>
    <div class="flex items-center gap-2">
        <TestingComplianceStatusIcon :status="status" :size="22" />
        <div class="flex flex-col leading-tight">
            <span
                v-if="operability === 'inoperable'"
                class="inline-flex items-center gap-1.5 self-start rounded-full border border-danger bg-danger/10 px-2 py-0.5 text-[0.8125rem] font-semibold text-body"
                :aria-label="`${label} — ${trans('dashboard.v2.testing_compliance.status.inoperable')}`"
            >
                <em class="h-3.5 w-3.5 shrink-0 rounded-full bg-danger" />
                {{ label }}
            </span>
            <span v-else class="text-[0.8125rem] font-semibold text-body">{{ label }}</span>
            <div class="mt-0.5 font-mono text-xs text-gray-text">{{ curieId }}</div>
        </div>
    </div>
</template>

<script setup>
import TestingComplianceStatusIcon from './TestingComplianceStatusIcon.vue';
import { trans } from '@/mixins/i18n';

defineProps({
    label: { type: String, required: true },
    curieId: { type: String, default: null },
    status: {
        type: String,
        required: true,
        validator: (v) => ['unscheduled', 'untested', 'pending', 'approved'].includes(v),
    },
    operability: {
        type: String,
        default: null,
    },
});
</script>
